import { Component, OnInit } from '@angular/core';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { ReportVitalSignsHourmeterService } from '../../services/report-vital-signs-hourmeter.service';

@Component({
  selector: 'app-report-vital-signs-hourmeter',
  templateUrl: './report-vital-signs-hourmeter.component.html',
  styleUrls: ['./report-vital-signs-hourmeter.component.scss'],
})
export class ReportVitalSignsHourometerComponent implements OnInit {
  public filterConfig: IFilterConfig;
  public selectedFilter: IOutputFilter;
  public tableConfig: ITableConfig;
  public tableData: any;
  public hasData: boolean;
  public message: string;
  public systemError: string;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;
  constructor(
    private vitalSignsHourmeterService: ReportVitalSignsHourmeterService,
    private tableConfigService: TableConfigService,
    private languageService: LanguageService,
    private datePipe: DatePresentationPipe,
    private layoutConfigService: LayoutConfigService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
  ) {
    this.hasData = false;
    this.message = '';
    this.disabledExcelBtn = false;
  }

  /** Init Component */
  public ngOnInit(): void {
    this.initLayoutConfig();
    this.initDefautlFilter();
  }

  /** Init Layout Report */
  public initLayoutConfig(): void {
    const configLayout: ILayoutConfig = {
      title: 'reporte',
      subtitle: 'report-signal-vital-hourmeter',
      imageKey: 'report',
      imageType: 'section',
    };

    this.layoutConfigService.setConfig(configLayout);
  }

  /** Init Default filter */
  public initDefautlFilter(): void {
    this.filterConfig = {
      dates: { required: true },
      shift: { required: true },
      machineType: { required: true, multiselect: true },
      machineList: { required: true, multiselect: true },
      cleanButton: true,
    };
  }

  // /** Fill table report */
  public fillTableHourmeterSignalVital(selectedFilter: IOutputFilter): void {
    this.selectedFilter = selectedFilter;
    this.filterConfig.isLoading = true;
    this.tableData = [];
    this.vitalSignsHourmeterService.GetVitalSignHourmeter(this.selectedFilter).then((result) => {
      this.tableData = [];
      for (const itemSignal of result) {
        this.tableData.push({
          machineName: itemSignal.machineName,
          machineTypename: itemSignal.machineTypename,
          shiftName: itemSignal.shiftName,
          vsTimestampAtStart: itemSignal.vsTimestampAtStart,
          hourMeterDurationAtStart: itemSignal.hourMeterDurationAtStart,
          vsTimestampAtEnd: itemSignal.vsTimestampAtEnd,
          hourMeterDurationAtEnd: itemSignal.hourMeterDurationAtEnd,
        });
      }

      if (result.length) {
        this.setTableConfig(this.tableData);
        this.filterConfig.isLoading = false;
        this.message = '';
        this.hasData = true;
      } else {
        this.hasData = false;
        this.message = this.languageService.message('m034');
        this.filterConfig.isLoading = false;
      }
    });
    const filters = {
      reports: 'report-vital-signs-hourmeter',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /** Set table config report */
  public setTableConfig(tableData: any, noDataMsgParam?: any): void {
    const headerParams: ITableHeaderParams = {
      data: tableData,
    };
    const datasetParams: ITableDataParams = {
      tableData,
      dateConfig: [
        { field: 'vsTimestampAtStart', format: 'date-time' },
        { field: 'vsTimestampAtEnd', format: 'date-time' },
      ],
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset }), 0);
  }

  /** Download file with report  */
  public downloadExcel(): void {
    const selectRangeDate = {
      startDate: this.datePipe.transform(this.selectedFilter.startDate),
      endDate: this.datePipe.transform(this.selectedFilter.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.vitalSignsHourmeterService.GetVitalSignHourmeterExcel(this.selectedFilter).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'report-signal-vital-hourmeter', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
